module.exports = __webpack_public_path__ + "static/media/4.0cdde098.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/baranovichi/4.jpg
// module id = 208
// module chunks = 0